<script>
export default {
  name: 'BButtonBase',

  inheritAttrs: false,

  props: {
    solid: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.button {
  display: inline-block;
  position: relative;
  padding: 8px 16px;
  vertical-align: middle;

  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-brand);

  background: transparent;
  border: 2px solid var(--color-brand);
  border-radius: 18px;

  transition: background-color 300ms;
}

.button:hover,
.button:focus {
  color: #fff;
  background-color: var(--color-brand);
}

.button[disabled] {
  background-color: transparent;
  color: var(--color-brand);

  opacity: 0.6;

  cursor: not-allowed;
}

.button--solid,
.button--solid[disabled] {
  color: #fff;
  background-color: var(--color-brand);
}

.button.is-busy {
  opacity: 1;
}

.button + .button {
  margin-left: 10px;
}

.button__content {
  transition: color 300ms;
}

.button.is-busy .button__content {
  color: transparent;
}

.button__busy {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  visibility: hidden;
  opacity: 0;

  transition:
    visibility 300ms,
    opacity 300ms;
}

.button.is-busy .button__busy {
  visibility: visible;
  opacity: 1;
}
</style>

<style>
.button ~ a {
  display: inline-block;
  margin-left: calc(var(--grid-spacing) / 2);
}
</style>
